<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <h1 class="title-pages">RESIDENTES</h1>
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <p class="mb-3 text-one">
            <i class="fas fa-search mr-1 icon-search"></i> Pesquisar
          </p>
          <v-text-field
            placeholder="Nome do residente"
            label="Informe o nome do residente"
            outlined
            v-model="search"
            @input="handleFilter"
          />
        </div>
      </div>
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div
            class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12 pt-1 pb-5"
            v-for="resident in residents"
            :key="resident.id"
          >
            <div
              class="
                card
                col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
                resident
                pt-0
                pb-0
              "
              @click="handleToResident(resident.id)"
            >
              <div>{{ resident.nickname }}</div>
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-4">
                  <img
                    class="photo-url"
                    :src="
                      permission('read', 'resident_photo') && resident.photo_url
                        ? resident.photo_url
                        : require('../assets/user.png')
                    "
                  />
                </div>
                <div
                  class="
                    col-xl-9 col-lg-9 col-md-8 col-sm-8 col-8
                    d-flex
                    flex-column
                    justify-content-center
                  "
                >
                  <h5 class="m-0 text-fifteen upper-text">
                    {{ resident.name }}
                  </h5>
                  <p class="m-0 worksansr upper-text text-fifteen">
                    {{ getAge(resident.date_of_birth) }} ANOS
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ErrorsMessages :errors="errors" />
        <div
          class="text-center v-clean p-5"
          v-show="residents.length == 0 && errors.length == 0"
        >
          <h6 class="text-center upper-text worksansr">Sem resultados!</h6>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import ErrorsMessages from "../templates/Components/ErrorsMessages";

import api from "../services/api";

import { getAge } from "../lib/getAgeByDate";

import routes from "../routes";

import permission from "../lib/permission";

export default {
  name: "Family",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
  },

  data() {
    return {
      search: "",

      data: [],
      residents: [],

      loading: false,

      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    getAge,

    handleFilter() {
      let { data, search } = this;

      let residents = data.filter(
        ({ name }) =>
          String(String(name).toLowerCase()).indexOf(
            String(search).toLowerCase()
          ) > -1
      );

      this.residents = residents;
    },

    async retrieve() {
      this.getResidents();
    },

    async getResidents() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/family/resident/dashboard");

        const { residents, error, errors } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.data = residents;
          this.residents = residents;
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleToResident: (id) =>
      routes.push({
        name: "family-resident",
        params: { id },
        query: {
          tab: "releases",
        },
      }),
  },
};
</script>

<style>
.resident {
  cursor: pointer;
}

.card-resident {
  cursor: pointer;
}

.photo_url {
  width: 100px !important;
  height: 100px !important;
  object-fit: contain !important;
  border-radius: 100%;
}
</style>
